/*
 * 路由对象模块
 * */
import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/guide/mapGuide'),
    meta: {
      title: '导览页',
    },
  },
  {
    path: '/guide',
    name: 'Guide',
    component: () => import('@/views/route/routeGuide'),
    meta: {
      title: '线路推荐',
    },
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import('@/views/custom/custom.vue'),
    meta: {
      title: '定制行程',
    },
  },
  {
    path: '/testMap',
    name: 'TestMap',
    component: () => import('@/views/map/testMap'),
  },
  {
    path: '/highBeat',
    name: 'HighBeat',
    component: () => import('@/views/photograph/highBeat'),
  },
  {
    path: '/photoShow',
    name: 'PhotoShow',
    component: () => import('@/views/photograph/photoShow'),
  },
];

const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHashHistory(),
  routes, // `routes: routes` 的缩写
});

export default router;
